import React, { useEffect } from "react";
const PIXEL_ID = "1037794919281360";
const PIXEL_SNIPPET = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`;
export function MetaPixel() {
  useEffect(() => {
    if (document.getElementById("meta-pixel-base")) return;
    const script = document.createElement("script");
    script.id = "meta-pixel-base";
    script.text = PIXEL_SNIPPET;
    document.head.appendChild(script);
  }, []);
  return <noscript data-id="element-38" data-mp="mkcmsgwa00t8">
      <img height="1" width="1" style={{
      display: "none"
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-39" data-mp="mkkxq38u8w1s" />
    </noscript>;
}